// import values from 'lodash/values';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

// import { change, SubmissionError } from 'redux-form';
import http from '../../../../../shared/http';
import endpoints from '../../../../../../config/endpoints';
import { createSelectOptionsFromSysEnums } from '../../../../../shared/form-elements/select';
import { actions as parentActions } from '../../../../../affiliates/profile';

const defaultInitialState = {
	listOfActivePanIndex: [],
	selectedCurrenciesPanIndexMap: {},
	offerDefaultTargets: {},
	offerTargetsForHighlight: {},
	nullifiedBoosts: [],
	field: {
		campaign_id: null,
		creating_date: null,
		closing_date: null
	}
};

const createIndividualTermsForm = ({ namespace, stateNodeName }) => {
	// action types
	const TERMS_FORM_SUBMIT_SUCCESS = `${namespace}/${stateNodeName}-submit-success`;

	const FETCH_SUGGEST_SUCCESS = `${namespace}/fetch-suggest-success`;
	const FETCH_SUGGEST_ERROR = `${namespace}/fetch-suggest-error`;

	const CHANGE_CURRENCY = `${namespace}/${stateNodeName}-change-currency`;

	const ALERT_ACCESS_SUCCESS = `${namespace}/${stateNodeName}-alert-access-success`;
	const ALERT_ACCESS_ERROR = `${namespace}/${stateNodeName}-alert-access-error`;

	const ALERT_DELETE_SUCCESS = `${namespace}/${stateNodeName}-alert-delete-success`;
	const ALERT_DELETE_ERROR = `${namespace}/${stateNodeName}-alert-delete-error`;

	const NULLIFY_BOOST = `${namespace}/${stateNodeName}-nullify-boost`;

	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = {
		alertsFormSubmit: formData => (dispatch, getState) => {
			const { affiliateId } = getState().affiliateProfile;
			const alerts = get(formData, 'alerts', []);
			const alertsIds = alerts.length > 0 ? alerts
				.map(item => {
					return !isEmpty(item) && {...item.alert[0], affiliate_id: affiliateId, campaign_id: item.alert[0].value};
				})
				.filter(alert => !alert.created_at && !isEmpty(alert)) : [];

			return dispatch(actions.alertsAccess(alertsIds)).then(action => {
				if (action && action.type === ALERT_ACCESS_SUCCESS) {
					dispatch(parentActions.toggleProgressBar());
					dispatch(parentActions.fetchAlerts(affiliateId));
				}
			});
		},

		alertsAccess: alertsIds => (dispatch, getState) => {
			if (isEmpty(alertsIds)) return Promise.resolve();
			const requestUrls = alertsIds.map(url=> endpoints.ALERTS.BASE);
			const request = http({
				url: requestUrls,
				method: 'post',
				actions: [ALERT_ACCESS_SUCCESS, ALERT_ACCESS_ERROR],
				data: alertsIds
			});

			return request(dispatch);
		},

		alertsLookups: text => (dispatch, getState) => {
			const affiliate_id = get(getState(), 'affiliateProfile.data.id', null);
			const request = http({
				url: `${endpoints.LOOKUPS.CAMPAIGNS}?query=${text}&affiliate_id=${affiliate_id}`,
				method: 'get',
				actions: [FETCH_SUGGEST_SUCCESS, FETCH_SUGGEST_ERROR]
			});

			return request(dispatch).then(action => {
				if (action.type === FETCH_SUGGEST_SUCCESS) {
					return {
						options: createSelectOptionsFromSysEnums(action.payload.data)
					};
				}
			});
		},

		deleteAlerts: alertId => (dispatch, getState) => {
			const { affiliateId } = getState().affiliateProfile;

			dispatch(parentActions.toggleProgressBar());

			const request = http({
				url: `${endpoints.ALERTS.BASE}/${alertId}`,
				method: 'put',
				actions: [ALERT_DELETE_SUCCESS, ALERT_DELETE_ERROR]
			});

			dispatch(request).then(action => {
				if (action.type === ALERT_DELETE_SUCCESS) {
					dispatch(parentActions.fetchOffers(affiliateId));
				}
			});
		}
	};

	// reducers
	const reducers = {

		[CHANGE_CURRENCY]: (state, action) => ({
			...state,
			individualTermsForm: {
				...state.individualTermsForm,
				selectedCurrenciesPanIndexMap: {
					...state.individualTermsForm.selectedCurrenciesPanIndexMap,
					[action.payload.index]: action.payload.currency
				}
			}
		}),

		[TERMS_FORM_SUBMIT_SUCCESS]: (state, action) => ({
			...state,
			individualTermsForm: {
				...state.individualTermsForm,
				offerDefaultTargets: {},
				listOfActivePanIndex: []
			}
		}),

		[ALERT_ACCESS_SUCCESS]: (state, action) => ({
			...state,
			individualAlertsForm: {
				...state.individualAlertsForm,
				offerDefaultTargets: {},
				listOfActivePanIndex: []
			}
		}),

		[NULLIFY_BOOST]: (state, action) => ({
			...state,
			individualTermsForm: {
				...state.individualTermsForm,
				// concat if not already in state
				nullifiedBoosts: find(state.individualTermsForm.nullifiedBoosts, {
					offerId: action.payload.offerId,
					locationId: action.payload.locationId
				})
					? state.individualTermsForm.nullifiedBoosts
					: state.individualTermsForm.nullifiedBoosts.concat(action.payload)
			}
		})
	};

	// selectors
	const selectors = {
		getFormData: state => {
			const {
				data,
				alerts,
				individualTerms,
				individualAlertsForm: {
					listOfActivePanIndex,
					selectedCurrenciesPanIndexMap,
					offerTargetsForHighlight,
					nullifiedBoosts
				}
			} = state.affiliateProfile;

			if (!alerts) return [];

			const prepareSavedOffers = getPreparedSavedAlerts(alerts, individualTerms);

			const initialValues = { alerts: [].concat(prepareSavedOffers) };
			const isMaster = data.is_master;

			return {
				initialValues,
				listOfActivePanIndex,
				selectedCurrenciesPanIndexMap,
				savedTerms: prepareSavedOffers,
				defaultTerms: offerTargetsForHighlight,
				nullifiedBoosts,
				isMaster
			};
		}
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

// functions
const getPreparedSavedAlerts = (alerts) =>
	alerts.map(alert => {
		return {
			alert: [
				{
					value: alert.id,
					label: alert.title,
					count: alert.alert_count,
					created_at: alert.created_at,
					removed_at: alert.removed_at
				}
			]
		};
	});

export default createIndividualTermsForm;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/forms/alerts/index.js